import {useIsTabletByScreen} from 'core/hooks/useIsTabletByScreen';
import {useEffect} from 'react';
import {useListingContext} from 'plugins/modules/listing/context';
import {IProductShort} from 'modules/products/types';

export const useProductsTileViewOnTablet = () => {
    const {view, handleChangeView} = useListingContext<IProductShort>();
    const isTablet = useIsTabletByScreen();

    useEffect(() => {
        if (isTablet && 'list' === view) {
            handleChangeView?.('tile');
        }
    }, [isTablet, handleChangeView, view]);
};
